export const formatLocationDisplayName = (location?: string, nationalityIso?: string): string => {
	if (!location) return '';

	// Taiwanese students should see Taiwan instead of "Taiwan (China)"
	if (nationalityIso === 'TW') {
		return location.replace('Taiwan (China)', 'Taiwan');
	}

	return location;
};
